(() => {
  const initializeBundleButtons = () => {
    document.querySelectorAll('[data-bundle-add]').forEach((button) => {
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';

      button.addEventListener('click', async () => {
        if (button.disabled) return;

        const status = button.closest('.sk-cart-bundles')?.querySelector('[data-bundle-status]');
        const defaultLabel = button.dataset.defaultLabel || button.textContent.trim();
        const addedLabel = button.dataset.addedLabel || defaultLabel;
        const loadingLabel = button.dataset.loadingLabel || defaultLabel;
        const errorLabel = button.dataset.errorLabel || defaultLabel;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = loadingLabel;

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(button.dataset.variantId),
                quantity: Math.max(1, Number(button.dataset.bundleQuantity) || 1)
              }]
            })
          });

          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || errorLabel);
          }

          button.textContent = addedLabel;
          if (status) status.textContent = addedLabel;
          window.location.reload();
        } catch (error) {
          button.disabled = false;
          button.textContent = defaultLabel;
          button.removeAttribute('aria-busy');
          if (status) {
            status.classList.remove('visually-hidden');
            status.textContent = error.message;
          }
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBundleButtons, { once: true });
  } else {
    initializeBundleButtons();
  }

  document.addEventListener('cartUpdated', initializeBundleButtons);

  const cartItems = document.getElementById('main-cart-items');
  if (cartItems) {
    new MutationObserver(initializeBundleButtons).observe(cartItems, {
      childList: true,
      subtree: true
    });
  }
})();
